import { useState, useEffect } from "react";

type useTableSearchProps = {
  searchVal: string | null;
  retrieve: () => any;
};

const useTableSearch = ({ searchVal, retrieve }: useTableSearchProps) => {
  const [filteredData, setFilteredData] = useState([]);
  const [origData, setOrigData] = useState([]);
  const [searchIndex, setSearchIndex] = useState<any>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true; // Flag to track if the component is still mounted
    setLoading(true);
    const crawl = (user: any, allValues: any) => {
      if (!allValues) allValues = [];
      for (var key in user) {
        if (typeof user[key] === "object") crawl(user[key], allValues);
        allValues.push(user[key] + " ");
      }
      return allValues;
    };
    const fetchData = async () => {
      try {
        const rows = await retrieve();
        if (!isMounted) return; // Exit if the component is unmounted
        const { data } = rows;
        if (!data) {
          console.error("Data is undefined or null");
        }
        if (isMounted) {
          setOrigData(data);
          setFilteredData(data);
          const searchInd = data?.map((data: any) => {
            const allValues = crawl(data, null);
            return { allValues: allValues.toString() };
          });
          setSearchIndex(searchInd);
          setLoading(false);
        }
      } catch (error) {
        if (isMounted) {
          console.error("Fetch error:", error);
          setLoading(false);
        }
      }
    };
    fetchData();
    return () => {
      isMounted = false; // Set flag to false when the component unmounts
    };
  }, [retrieve]);

  useEffect(() => {
    if (searchVal) {
      const reqData = searchIndex?.map((data: any, index: number): any => {
        if (data.allValues.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0)
          return origData[index];

        return null;
      });

      setFilteredData(
        reqData.filter((data: any): boolean => {
          if (data) return true;
          return false;
        }),
      );
    } else setFilteredData(origData);
  }, [searchVal, origData, searchIndex]);

  return { filteredData, loading };
};

export default useTableSearch;
